import _ from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import { UngradedLabItemActionNames } from 'bundles/item-ungraded-lab/actions/UngradedLabItemActionNames';
import type { WorkspaceV2Launcher } from 'bundles/labs-common/types/WorkspaceApiTypes';

const SERIALIZED_PROPS: Array<keyof SerializedState> = ['launcher'];

type SerializedState = {
  launcher?: WorkspaceV2Launcher;
};

class UngradedLabItemStore extends BaseStore {
  launcher?: WorkspaceV2Launcher = undefined;

  declare emitChange: () => void;

  static storeName = 'UngradedLabItemStore';

  static handlers = {
    [UngradedLabItemActionNames.SetUngradedLab]: 'setUngradedLab',
    [UngradedLabItemActionNames.ClearUngradedLab]: 'clearUngradedLab',
  };

  hasLoaded() {
    return !!this.launcher;
  }

  getState(): SerializedState {
    return _.pick(this, ...SERIALIZED_PROPS);
  }

  dehydrate(): SerializedState {
    return this.getState();
  }

  rehydrate(state: SerializedState) {
    const stateObserved = _.pick(state, ...SERIALIZED_PROPS);
    Object.assign(this, stateObserved);
  }

  getLauncher(): WorkspaceV2Launcher | undefined {
    return this.launcher;
  }

  setUngradedLab({ launcher }: { launcher: WorkspaceV2Launcher }): void {
    this.launcher = launcher;
    this.emitChange();
  }

  clearUngradedLab(): void {
    this.launcher = undefined;
    this.emitChange();
  }
}

export default UngradedLabItemStore;
